import React, { useState } from 'react';
import { useThrottleFn, useMemoizedFn } from 'ahooks';
import { Anchor } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

interface EcoAnchorProps {
    isLogin: boolean;
}
const { Link } = Anchor;
let interObserver: IntersectionObserver | null = null;
const EcoAnchor: React.FC<EcoAnchorProps> = ({ isLogin }) => {
    const { useLang, useEffect, isMobile } = useGlobal();
    const { t } = useLang('membership');
    const [show, setShow] = useState(false);
    const [tabPosition, setTabPosition] = useState({
        tabWidth: 0,
        offsetLeft: 0,
    });
    // 活动的临时导航
    const [navArr, setNavArr] = useState<
        | {
              href: string;
              title: string;
          }[]
        | null
    >(null);

    const onActiveChange = (currentActiveLink: string) => {
        if (!currentActiveLink) {
            setTabPosition({
                ...tabPosition,
                tabWidth: 0,
            });
            return;
        }
        const currLink = document.querySelector<HTMLLinkElement>(`.ant-anchor-link-title-active[href="${currentActiveLink}"]`);
        if (!currLink) return;
        const { clientWidth, offsetLeft } = currLink;
        setTabPosition({
            tabWidth: clientWidth,
            offsetLeft,
        });
        if (!isMobile) return;
        scrollBar(offsetLeft);
    };

    const { run: onActiveChangeRun } = useThrottleFn(onActiveChange, {
        wait: 100,
        leading: false,
    });

    const scrollBar = useMemoizedFn((offsetLeft: number) => {
        const wrapper = document.querySelector<HTMLDivElement>('.ant-anchor-wrapper');
        if (!wrapper) return;

        wrapper.scrollTo({
            left: offsetLeft - 20,
            behavior: 'smooth',
        });
    });

    useEffect(() => {
        // 导航栏数据初始化
        setNavArr([
            {
                href: '#EcoCredit_Program',
                title: t('nav1'),
            },
            {
                href: '#EcoCredits_Benefits',
                title: t('nav2'),
            },
            {
                href: '#How_to_Earn',
                title: t('nav3'),
            },
            {
                href: '#ECO_FAQ',
                title: t('nav4'),
            },
        ]);
        if (!isLogin) {
            setShow(true);
        } else {
            // 隐藏导航栏
            const apperCb: IntersectionObserverCallback = (params: IntersectionObserverEntry[]) => {
                const data = params[0];
                const calIconStatus = data.intersectionRatio <= 0;
                console.log(data.intersectionRatio);
                setShow(calIconStatus);
            };

            interObserver && interObserver.disconnect();
            interObserver = new IntersectionObserver(apperCb);

            const targetEle = document.querySelector('#summary-content');
            console.log(targetEle);
            if (targetEle) {
                interObserver.observe(targetEle as HTMLElement);
            }
        }
        // 移动端移动导航栏位置
        const firstLink = document.querySelector<HTMLLinkElement>(`.ant-anchor-link-title[href="#WAYS_TO_EARN_POINTS"]`);
        if (!firstLink) return;
        const { offsetLeft } = firstLink;
        setTabPosition({
            tabWidth: 0,
            offsetLeft,
        });

        return () => {
            interObserver && interObserver.disconnect();
        };
    }, []);

    if (!show) return <></>;

    return (
        <div className={`${css.eco_anchor} ${isLogin ? 'login' : ''}`}>
            <Anchor targetOffset={150} showInkInFixed={false} offsetTop={60} onChange={onActiveChangeRun}>
                {navArr?.map((item: any) => (
                    <Link href={item.href} title={item.title} key={item.title} />
                ))}
                <span
                    className="active-line"
                    style={{
                        width: `calc(${tabPosition.tabWidth}px)`,
                        left: `calc(${tabPosition.offsetLeft}px)`,
                    }}
                />
            </Anchor>
        </div>
    );
};

export default EcoAnchor;
